// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__fsXY_","button":"styles_button___Azu_","clearButton":"styles_clearButton__s_Zta","submitButton":"styles_submitButton__i3hQZ"};